module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_Promo21.796ab2e4.jpg";